import KeycloakProvider from '@/providers/KeycloakProvider';
import ThemeProvider from '@/providers/ThemeProvider';
import { App, ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import ErrorBoundary from './components/common/ErrorBoundary';
import './index.css';
import AppProvider from './providers/AppProvider';
import AppRouter from './router/AppRouter';
import { store } from './store/store.js';
import './styles/global.less';
import './styles/pagination.less';
import { setupGlobalErrorHandlers } from './utils/errorHandler';
import { initSentry } from './utils/sentry';

// Initialize Sentry
initSentry({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_ENV || import.meta.env.MODE,
  release: import.meta.env.VITE_APP_VERSION || '2.0.0',
});

// Setup global error handlers
setupGlobalErrorHandlers();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <KeycloakProvider>
          <ConfigProvider locale={enUS}>
            <ThemeProvider>
              <App>
                <AppProvider>
                  <AppRouter />
                </AppProvider>
              </App>
            </ThemeProvider>
          </ConfigProvider>
        </KeycloakProvider>
      </Provider>
    </ErrorBoundary>
  </StrictMode>
);
